import { parsePrimitiveEpisode } from './_pure/episode';
import { createPrimitiveScenePlanResolver, resolvePrimitiveEpisode } from './episodeCatalog';
import { primitiveEpisodeAuditions } from './scenePlanAuditions';
import { primitiveVisualSources } from './visualSourceCatalog';
import type { EpisodeSupport } from '@/_contract/episodeSupport';
import type { Config, CosmosDataModel, RuntimeState } from './_contract/config';
import type { PrimitiveEpisode, PrimitiveScene } from './_contract/episode';

const resolveTrace = createPrimitiveScenePlanResolver();

export const primitiveEpisodeSupport = {
    parseEpisode: (value: unknown) => parsePrimitiveEpisode(value, primitiveVisualSources),
    resolveScene: resolvePrimitiveEpisode,
    concept: { effectKinds: ['emphasis', 'orbit'] },
    trace: {
        effectKinds: ['emphasis', 'orbit', 'pointer-sweep'],
        visualPresentation: true,
        actionStartCues: true,
        excerpts: true,
        resolve: (args) => resolveTrace(args.config, args.handle, args.sceneIndex),
    },
    auditions: primitiveEpisodeAuditions,
} satisfies EpisodeSupport<Config, RuntimeState, CosmosDataModel, PrimitiveEpisode, PrimitiveScene>;
